import { contactFormApi } from './contactFormApi'
import { getquoteApi } from './getquoteApi'
import { jobApplicationApi } from './jobApplicationApi'
import { serviceApi } from './serviceApi'

 
const apiCalls={
    contactFormApi,
    jobApplicationApi,
    serviceApi,
    getquoteApi,
}
export {apiCalls}